import React, { useEffect, useRef, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import AxiosClient from '../../assets/AxiosClient';
import defult from './defult.jpg';
import { useStateContext } from '../../Contexts/ContextProvider';

const EditSponsor = () => {
  const { id } = useParams();
  const nameRef = useRef(null);
  const descriptionRef = useRef(null);
  const logoRef = useRef(null);
  const websiteRef = useRef(null);
  const typeRef = useRef(null);
  const activeRef = useRef(null);

  const [isImageUploaded, setIsImageUploaded] = useState(false);
  const [imagePreviewUrl, setImagePreviewUrl] = useState(null);
  const { API } = useStateContext();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSponsor = async () => {
      try {
        const response = await AxiosClient.get(`/sponsors/${id}`);
        const sponsorData = response.data;

        nameRef.current.value = sponsorData.name;
        descriptionRef.current.value = sponsorData.description;
        logoRef.current.value = sponsorData.logo;
        websiteRef.current.value = sponsorData.website;
        typeRef.current.value = sponsorData.type;
        activeRef.current.checked = sponsorData.active;

        setImagePreviewUrl(`${API}${sponsorData.logo}`);
      } catch (error) {
        console.error('Error fetching sponsor:', error);
      }
    };

    fetchSponsor();
  }, [id, API]);

  const handleImageChange = (e) => {
    setIsImageUploaded(true);
    const selectedImage = e.target.files[0];

    const reader = new FileReader();
    reader.onload = (event) => {
      setImagePreviewUrl(event.target.result);
    };
    reader.readAsDataURL(selectedImage);
  };

  const handleCancel = () => {
    navigate("/sponsors");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      name: nameRef.current.value,
      description: descriptionRef.current.value,
      logo: logoRef.current.value,
      website: websiteRef.current.value,
      type: typeRef.current.value,
      active: activeRef.current.checked,
    };

    try {
      await AxiosClient.put(`/sponsors/${id}`, payload);
      alert('Sponsor updated successfully');
      navigate("/sponsors");
    } catch (error) {
      console.error('Error updating sponsor:', error);
    }
  };

  return (
    <div className="m-4">
      <form className="form-group">
        <h5>Name</h5>
        <div className="input-group input-group-outline mb-3">
          <input type="text" className="form-control" placeholder="Enter name" ref={nameRef} required />
        </div>

        <h5>Description</h5>
        <div className="input-group input-group-outline mb-3">
          <textarea className="form-control" placeholder="Enter description" rows={5} ref={descriptionRef} />
        </div>

        <h5>Logo</h5>
        <div className="w-full flex flex-wrap items-center">
          <label htmlFor="logo" className="w-full block mb-2 font-medium text-gray-700 m-2">
            Sponsor Logo:
          </label>
          <input
            type="file"
            id="logo"
            accept="image/*"
            onChange={handleImageChange}
            className="py-2 m-2 px-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <img
          src={imagePreviewUrl ? imagePreviewUrl : defult}
          alt="Uploaded"
          style={{ maxWidth: '250px', maxHeight: '250px' }}
          className="w-full object-contain mb-w-100 text-center"
        />

        <hr className="border-gray-300 my-4" />

        <h5>Website</h5>
        <div className="input-group input-group-outline mb-3">
          <input type="text" className="form-control" placeholder="Enter website" ref={websiteRef} />
        </div>

        <h5>Type</h5>
        <div className="input-group input-group-outline mb-3">
          <input type="text" className="form-control" placeholder="Enter type" ref={typeRef} />
        </div>

        <h5>Active</h5>
        <div className="form-check">
          <input type="checkbox" className="form-check-input" id="active" ref={activeRef} />
          <label className="form-check-label" htmlFor="active">Active</label>
        </div>

        <button onClick={handleSubmit} className="btn btn-success m-2">
          Save
        </button>
        <button onClick={handleCancel} className="btn btn-danger m-2">
          Cancel
        </button>
      </form>
    </div>
  );
};

export default EditSponsor;
